export const getTagNo = (tag) => tag && (tag.noTag != null ? tag.noTag : tag.no);

export const getTagName = (tag) => (tag && tag.name) || `Tag #${getTagNo(tag)}`;

export const normalizeTagName = (value) => String(value || '').trim().toLowerCase();

export const buildSelectedMap = (tags = []) => {
   const selected = {};
   (tags || []).forEach((tag) => {
      const noTag = getTagNo(tag);
      if (noTag != null) selected[String(noTag)] = true;
   });
   return selected;
};

export const sameTagSelection = (left = {}, right = {}) => {
   const leftKeys = Object.keys(left).filter((key) => left[key]).sort();
   const rightKeys = Object.keys(right).filter((key) => right[key]).sort();
   return leftKeys.length === rightKeys.length && leftKeys.every((key, index) => key === rightKeys[index]);
};
